<template>
  <div class="page height-full">
    <app-header title="Accounts"/>
    <div class="container-fluid" v-if="isLoading">
      <spinner style="margin-top: 25%"></spinner>
    </div>
    <div class="container-fluid" v-else>
      <div v-for="account in accounts">
        <b-row>
          <div class="col-md-12 mt-2 mb-2">
            <div class="counter-box white r-5 p-3">
              <div class="p-3">
                <div class="counter-title mb-3">{{account.name}}</div>
                <a href="#" @click="viewDashboard(account.pk)">View Dashboard</a> | 
                <a href="#" @click="viewUsers(account.pk)">Manage Users</a>
              </div>
            </div>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { Auth } from 'aws-amplify';
  import axios from 'axios'
  import Constants from '../Constants'
  import Spinner from './common/Spinner'
  import SimpleChart from './SimpleChart'
  import Vue from 'vue'
  

  export default {
    name: 'Home',
    components: {
      Spinner,
      SimpleChart
    },
    data() {
      return {
        accounts: [],
        isLoading: false,
        isAdmin: false,
      }
    },
    methods: {
      visit(url) {
        // window.location.href = url
      },
      viewUsers(pk) {
        const id = pk.split('|')[1]
        this.$router.push('/accounts/' + id + '/users')
      },
      getAccounts() {
        this.isLoading = true
        axios.get(Constants.API_URL + "/accounts")
          .then(response => {
            console.log(response)
            this.accounts = response.data.Items
            if (this.accounts.length == 1) {
              const id = this.accounts[0].pk.split('|')[1]
              this.$router.push('/accounts/' + id)
            }
          }).catch(err => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      },
      viewDashboard(pk) {
        const id = pk.split('|')[1]
        this.$router.push('/accounts/' + id)
      },
      billing() {
        if (localStorage.stripeCustomerId) {
          axios.get(Constants.API_URL + '/stripe/billing?customerId=' + localStorage.stripeCustomerId)
            .then(response => {
              if (response.data.url) {
                window.location.href = response.data.url
              }
            }).catch(err => {
              console.error(err)
            })
        } else {
          this.$router.push('/plans')
        }
      }
    },
    computed: {
      showUpgradeBanner: function() {
        return this.plan !== 'subscribed'
      }
    },
    mounted() {
      Auth.currentAuthenticatedUser()
        .then(user => {
          user.signInUserSession.accessToken.payload['cognito:groups'].forEach(role => {
            if (role == "admin") { 
              this.isAdmin = true 
            }
          })

          if (this.isAdmin == true) {
            window.location.href = "/admin"
          } else {
            this.getAccounts()
          }
        }).catch(err => {
          console.error(err)
        })
    }
  }
</script>
<style>
  .alert {
    margin-top: 16px;
  }

  .credits {
    color: dimgray;
  }

  .upgrade {
    position: relative;
    float: right;
  }

  .upgrade a {
    text-decoration: blue;
  }

  .description {
    margin-top: 20px;
  }

  .md-dialog-actions {
    justify-content: center;
    padding: 0;
  }

  .centered {
    text-align: center;
    display: block;
    width: 100%;
  }

  .content {
    margin-left: 100px;
    margin-right: 100px;

  }

  .content-bottom {
    margin-bottom: 50px;
  }

  .btn-gray {
    margin-bottom: 20px;
    background-color: #e3e3e3;
    color: white;
    text-align: center;
  }

  .counter-box {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue